module.exports = __webpack_public_path__ + "static/media/Bruno.ef4458aa.png";